import { render } from "./AssistantDetails.vue?vue&type=template&id=787d9b2c"
import script from "./AssistantDetails.vue?vue&type=script&lang=js"
export * from "./AssistantDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__